import { IEvent } from '@studyportals/event-aggregation-service-interface';
import { InlineSearchCommands } from '../enums';

export class InlineSearchAppInitialInput implements IEvent {
	public static readonly EventType = InlineSearchCommands.INLINE_SEARCH_APP_INITIAL_INPUT_EVENT;

	public readonly timestamp = new Date();
	public readonly eventType = InlineSearchAppInitialInput.EventType;
	public readonly input: string;

	constructor(input: string) {
		this.input = input;
	}

	public static is(event: IEvent): event is InlineSearchAppInitialInput {
		return event.eventType === InlineSearchAppInitialInput.EventType as string;
	}
}